import { render, staticRenderFns } from "./QueueEntry.vue?vue&type=template&id=70fb3242&scoped=true"
import script from "./QueueEntry.vue?vue&type=script&lang=ts"
export * from "./QueueEntry.vue?vue&type=script&lang=ts"
import style0 from "./QueueEntry.vue?vue&type=style&index=0&id=70fb3242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb3242",
  null
  
)

export default component.exports